import { render, staticRenderFns } from "./rankingListOfHomeowners.vue?vue&type=template&id=0142af4f&scoped=true&"
import script from "./rankingListOfHomeowners.vue?vue&type=script&lang=js&"
export * from "./rankingListOfHomeowners.vue?vue&type=script&lang=js&"
import style0 from "./rankingListOfHomeowners.vue?vue&type=style&index=0&id=0142af4f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0142af4f",
  null
  
)

export default component.exports